module.exports = __webpack_public_path__ + "static/img/tips.d31bdfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tips.png
// module id = efiO
// module chunks = 1